enum ERevalidatePeriods {
  NONE = 0,
  TEN_SECONDS = 10,
  THIRTY_SECONDS = 30,
  ONE_MINUTE = 60,
  TEN_MINUTES = 600,
  ONE_HOUR = 3600,
  FOUR_HOURS = 14400,
  EIGHT_HOURS = 28800,
  ONE_DAY = 86400,
  ONE_WEEK = 604800,
}

export const REVALIDATE_PERIOD = process.env.REVALIDATE_PERIOD
  ? parseInt(process.env.REVALIDATE_PERIOD, 10)
  : ERevalidatePeriods.TEN_MINUTES;

export const IS_DEV = process.env.NODE_ENV === 'development';
// eslint-disable-next-line import/no-unused-modules
export const HC_IS_FEATURE_BRANCH = process.env.HC_IS_FEATURE_BRANCH === 'true';
// eslint-disable-next-line import/no-unused-modules
export const HC_IS_STAGE = process.env.HC_IS_STAGE === 'true';
export const HC_IS_PROD = process.env.HC_IS_PROD === 'true';
// Прокси для Sentry (config/sentry/sentry-init-config.boiler.ts)
export const IS_PROD = HC_IS_PROD;
